import { Component } from '@angular/core';
import { LoadingController, NavParams,ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoService } from '../../../../services/rodeo.service';
import { AlertMessager } from '../../../../lib/alertMessager';
import { TextAdvertisement } from '../../../../model/textAdvertisement';
import { NotificationService } from '../../../../services/texting.service';
import { AccountHelper } from '../../../../lib/accountHelper';

@Component({
    selector: 'page-text-prompt',
    templateUrl: 'text-prompt.html'
})
export class TextPromptPage {
    rodeo: Rodeo;
    rodeoEvent: any;
    schedule: any;
    textAdvertisement: TextAdvertisement = new TextAdvertisement();
    contestantCount: number;

    allSchedules: any[];

    popoverActive: boolean;

    constructor(private viewController: ViewController, private navParams: NavParams, private loadingControl: LoadingController,
        private rodeoService: RodeoService, private alert: AlertMessager, private textingService: NotificationService) {
        this.rodeo = this.navParams.get('rodeo');
        this.rodeoEvent = this.navParams.get('rodeoEvent');
        this.schedule = this.navParams.get('schedule');

        this.allSchedules = [];
        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            if (!this.rodeoEvent)
                this.rodeoEvent = rodeoEvent;

            rodeoEvent.schedules.forEach((schedule) => {
                if (!this.allSchedules.find(x => x.name.toLowerCase().trim() == schedule.name.toLowerCase().trim()))
                    this.allSchedules.push((schedule));
            })
        });

        if (!this.schedule)
            this.schedule = 'All';

        this.updateContestantCount();
    }

    updateClassSelection() {
        if (this.rodeoEvent != 'All' && this.schedule != 'All') {
            const matchingSchedule = this.rodeoEvent.schedules.find(x => x.name == this.schedule.name)

            if (!matchingSchedule)
                this.schedule = 'All';
            else
                this.schedule = matchingSchedule;
        }

        this.updateContestantCount();
    }

    updateScheduleSelection() {
        this.updateContestantCount();
    }

    updateContestantCount() {
        let rodeoEvents = [this.rodeoEvent];

        if (this.rodeoEvent == 'All') {
            rodeoEvents = this.rodeo.rodeoEvents;
        }

        let schedules = rodeoEvents.flatMap(x => x.schedules);

        if (this.schedule != 'All') {
            schedules = rodeoEvents.flatMap(x => x.schedules).filter(x => x.name == this.schedule.name);
        }

        var contestants = schedules.flatMap(x => x.runs).map(x => x.contestantOneId);
        var partners = schedules.flatMap(x => x.runs).filter(x => x.contestantTwoId != null).map(x => x.contestantOneId);

        if (partners.length > 0)
            contestants.push(partners);

        console.log("contestants: ", contestants);
        this.contestantCount = new Set(contestants).size;
    }

    async sendText() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let loader = this.loadingControl.create({
            content: 'Sending out texts...',
        });

        if (this.schedule != 'All') {
            this.textAdvertisement.schedules = [];
            this.textAdvertisement.schedules.push(this.schedule.id);
        }

        if (this.rodeoEvent != 'All') {
            this.textAdvertisement.rodeoEvents = [];
            this.textAdvertisement.rodeoEvents.push(this.rodeoEvent.id);
        }

        this.textAdvertisement.rodeos = [];
        this.textAdvertisement.rodeos.push(this.rodeo.id);

        loader.present();
        this.textingService.sendTexts(this.textAdvertisement, false, "")
            .then((data) => {
                this.popoverActive = false;
                loader.dismiss();
                this.alert.showConfirmation("Success", data + " Texts Successfully Sent");
            }, error => {
                this.popoverActive = false;
                loader.dismiss();
                this.alert.showError("Text Send Error", error);
            })
    }
    
    async sendPush() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let loader = this.loadingControl.create({
            content: 'Sending out pushes...',
        });

        if (this.schedule != 'All') {
            this.textAdvertisement.schedules = [];
            this.textAdvertisement.schedules.push(this.schedule.id);
        }

        if (this.rodeoEvent != 'All') {
            this.textAdvertisement.rodeoEvents = [];
            this.textAdvertisement.rodeoEvents.push(this.rodeoEvent.id);
        }

        this.textAdvertisement.rodeos = [];
        this.textAdvertisement.rodeos.push(this.rodeo.id);

        loader.present();
        this.textingService.sendPushes(this.textAdvertisement, null)
            .then((data) => {
                this.popoverActive = false;
                loader.dismiss();
                this.alert.showConfirmation("Success", data + " Pushes Successfully Sent");
            }, error => {
                this.popoverActive = false;
                loader.dismiss();
                this.alert.showError("Text Send Error", error);
            })
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/draw/text-prompt.ts